module.exports = __webpack_public_path__ + "media/images/icons/simple_and_digital-bf437a330261fd78b68898c9a1bfa9e8.svg";